import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Card } from 'react-bootstrap';
import NavbarComponent from './NavbarComponent';
import Footer from './Footer';
import MerchandiseModal from './MerchandiseModal';

const HomePage = () => {
  const [merchandiseItems, setMerchandiseItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [companies, setCompanies] = useState([]);
  const CACHE_EXPIRATION = 1 * 60 * 1000; // 1 minute in milliseconds

  useEffect(() => {
    const fetchData = async () => {
      // Check if data is cached
      const cachedData = localStorage.getItem('merchandiseData');
      const cachedCompanies = localStorage.getItem('companyData');
      const cacheTime = localStorage.getItem('cacheTime');

      const currentTime = new Date().getTime();

      if (cachedData && cachedCompanies && currentTime - cacheTime < CACHE_EXPIRATION) {
        setMerchandiseItems(JSON.parse(cachedData));
        setCompanies(JSON.parse(cachedCompanies));
      } else {
        try {
          const response = await fetch('https://api.airtable.com/v0/appWI09FiPgQXRTxb/bakaaro', {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_AIRTABLE_API_KEY}`,
            },
          });
          const data = await response.json();

          // Filter items by truthy value of status field
          const filteredItems = data.records.filter((item) => item.fields.Status === "Displayable");

          // Sort items by company name
          filteredItems.sort((a, b) => a.fields.company_name[0] - b.fields.company_name[0]);

          setMerchandiseItems(filteredItems);

          // Extract unique companies from merchandiseItems
          const uniqueCompanies = [...new Set(filteredItems.map((item) => item.fields.company_name[0]))];
          setCompanies(uniqueCompanies);

          // Cache the data
          localStorage.setItem('merchandiseData', JSON.stringify(filteredItems));
          localStorage.setItem('companyData', JSON.stringify(uniqueCompanies));
          localStorage.setItem('cacheTime', currentTime);
        } catch (error) {
          console.error('Error fetching data from Airtable:', error);
        }
      }
    };

    fetchData();
  }, [CACHE_EXPIRATION]);

  const handleItemClick = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleAddItem = () => {
    window.open('https://airtable.com/shrr75q9AbUv96KKn', '_blank');
  };

  return (
    <div className="home-page">
      <NavbarComponent handleAddItem={handleAddItem} companies={companies} />
      <div className="bg-light text-center py-4">
        <h1>B A K A A R O</h1>
        <p className="lead">
          <em>The #1 Marketplace for Modest Fashion</em>
        </p>
      </div>
      <Container className="mt-4">
        <Row xs={1} sm={2} md={3} lg={4} className="row-cols-md-4 g-2">
          {merchandiseItems.map((item) => (
            <div key={item.id} className="col mb-3">
              <Card
                onClick={() => handleItemClick(item)}
                className="h-100 d-flex flex-column justify-content-between text-center"
                style={{ cursor: 'pointer' }}
              >
                <Card.Img
                  variant="top"
                  src={item.fields.picture[0].url}
                  alt={item.fields.name}
                  className="card-image"
                  style={{ height: '250px', objectFit: 'cover' }}
                />
                <Card.Body className="d-flex flex-column">
                  <Card.Title className="card-title mb-2">{item.fields.name}</Card.Title>
                  <Card.Text className="card-text">
                    <em>{item.fields.company_name}</em>
                  </Card.Text>
                  <Card.Text className="card-text mb-2">
                    <strong>${item.fields.price}</strong>
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
          ))}
        </Row>
      </Container>
      {selectedItem && <MerchandiseModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        selectedItem={selectedItem.fields}
      />}
      <Footer />
    </div>
  );
};

export default HomePage;
